// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__UGtEL","cell":"ColumnAccessor_cell__1V5pn","firstCellAccent":"ColumnAccessor_firstCellAccent__2w4bx"};